"use strict";

function __export(m) {
  for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./Observable"));

__export(require("./types"));

var _isEmpty = require("lodash/isEmpty");

var _isEqual = require("lodash/isEqual");

var _merge = require("lodash/merge");

var _some = require("lodash/some");

exports.isEmpty = _isEmpty;
exports.isEqual = _isEqual;
exports.merge = _merge;
exports.some = _some;
/**
 * Check whether the object is a promise.
 */

exports.isPromise = function (obj) {
  return obj && typeof obj.then === 'function';
};